export const PAYMENT_METHOD = { 
    1: 'Cash',
    2: 'Online Payment',
    3: 'Revolving Fund',
    4: 'Invoice Financing'
}

export const INVOICE_FINANCING_ID = 4;

// this is for radio buttom
export const PAYMENT_METHOD_OPTIONS = Object.fromEntries(
    Object.entries(PAYMENT_METHOD).map(([id, label]) => [label, Number(id)])
);

// this is for dropdown data
export const PAYMENT_METHOD_DROPDOWN = Object.entries(PAYMENT_METHOD).map(([id, label]) => ({
    label,
    status: Number(id)
}));
